import api from "./api";

// -------------------- BUNCH SIZES --------------------
export const fetchBunchSizes = async () => {
  const res = await api.get("/core/bunch-sizes/");
  return res.data;
};

export const createBunchSize = async (payload) => {
  const res = await api.post("/core/bunch-sizes/", payload);
  return res.data;
};

export const updateBunchSize = async (id, payload) => {
  const res = await api.patch(`/core/bunch-sizes/${id}/`, payload);
  return res.data;
};

export const deleteBunchSize = async (id) => {
  const res = await api.delete(`/core/bunch-sizes/${id}/`);
  return res.data;
};
